import { render, staticRenderFns } from "./Keyboard.vue?vue&type=template&id=0fcbb16c&scoped=true"
import script from "./Keyboard.vue?vue&type=script&lang=ts"
export * from "./Keyboard.vue?vue&type=script&lang=ts"
import style0 from "./Keyboard.vue?vue&type=style&index=0&id=0fcbb16c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcbb16c",
  null
  
)

export default component.exports